module.exports = __webpack_public_path__ + "img/QR.f25e12e1.png";